// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../types';
import { media } from '../../helpers';
import Button from '../button/button.styled';
import { LinkStyled } from '../link';

type Props = {
  justify?: 'flex-start' | 'flex-end' | 'center' | 'space-between';
  direction?: 'row' | 'column',
};

const ButtonBar = styled<any, Theme, Props>('section')`
  display: flex;
  flex-wrap: wrap;
  flex-direction: ${props => props.direction};
  justify-content: ${props => props.justify};

  ${/* sc-sel */Button},
  ${/* sc-sel */LinkStyled} {
    align-self: ${props => (props.direction === 'row' ? 'flex-start' : props.justify)};
  }

  ${/* sc-sel */Button} + ${/* sc-sel */Button},
  ${/* sc-sel */LinkStyled} + ${/* sc-sel */LinkStyled} {
    ${media.sm(css`
      margin-left: ${props => (props.direction === 'row' ? '1rem' : 0)};
    `)}
  }
`;

export default ButtonBar;
